import classnames from 'classnames';
import Button from 'components/Button';
import Loading from 'components/Loading';
import RadioGroup from 'components/RadioGroup';

import { Map } from 'immutable';
import { get, values } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { moment } from 'utils';
import ServiceSelectContainer from '../../containers/ServiceSelectContainer';
import SlotSelectContainer from '../../containers/SlotSelectContainer';
import TaxAuthoritySelectContainer from '../../containers/TaxAuthoritySelectContainer';
import isManagement from '../../utils/isManagement';
import Warning from '../../../../components/Warning/index';
import errorMessages from '../../../../constants/errorMessages';
import InfoMessage from 'components/InfoMessage/InfoMessage';
import styles from 'modules/Contacts/components/TaxAuthoritySelect/private/TaxAuthoritySelectBlock.module.scss';
import { defaultMessages } from 'modules/Contacts/components/TaxAuthoritySelect/constants';
import REACT_CONFIG from 'REACT_CONFIG';

export const defaultFaceId = 8;

export default class MakeAppointment extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
    contacts: PropTypes.instanceOf(Map).isRequired,
    externalTaxAuthority: PropTypes.instanceOf(Map).isRequired,
    appointment: PropTypes.instanceOf(Map).isRequired,
    makeAppointment: PropTypes.func.isRequired,
    goToAppointment: PropTypes.func.isRequired,
    setAppointmentDetail: PropTypes.func.isRequired,
    getExternalTaxAuthority: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    managements: PropTypes.instanceOf(Map),
    taxAuthorities: PropTypes.instanceOf(Map),
    taxAuthorityAffiliates: PropTypes.instanceOf(Map),
    services: PropTypes.instanceOf(Map),
    slots: PropTypes.instanceOf(Map),
    getManagement: PropTypes.func,
  };

  state = {
    taxCode: this.props.router.query.taxCode || '-1',
    selectedInspection: null,
    otherInspection: null,
    service: null,
    timeSlot: null,
  };

  componentDidMount() {
    const { reset, externalTaxAuthority, getExternalTaxAuthority, getManagement } = this.props;
    const { taxCode } = this.state;
    const taxAuthority = externalTaxAuthority.getIn(['data', taxCode]);
    getManagement();
    reset();

    if (taxCode !== '-1' && !taxAuthority) {
      getExternalTaxAuthority(taxCode);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { appointment, goToAppointment, externalTaxAuthority } = nextProps;
    const { taxCode } = this.state;
    const taxAuthority = externalTaxAuthority.getIn(['data', taxCode]);
    const data = appointment.get('data') || {};

    if (!data.error && data.bookId) {
      goToAppointment(data.bookId);
    }

    if (taxAuthority) {
      this.setState({
        selectedInspection: taxAuthority,
      });
    }
  }

  getInspectionsItems = (inspections) => {
    let items = inspections
      .filter((inspection) => {
        const taxCode = inspection.taxCode || '';
        return !isManagement(taxCode, inspection.type);
      })
      .sort((inspection1, inspection2) => {
        const codeDiff = inspection1.taxCode - inspection2.taxCode;
        return codeDiff > 0 ? 1 : -1;
      })
      .map((inspection) => {
        return {
          label: `${inspection.taxCode} – ${inspection.name}`,
          value: inspection.taxCode,
        };
      });

    items.push({
      label: 'Другой налоговый орган',
      value: '-1',
    });

    return items;
  };

  onSelectInspection = (value) => {
    const { externalTaxAuthority } = this.props;
    const inspection = ~value ? externalTaxAuthority.getIn(['data', value]) : null;

    this.setState(
      {
        taxCode: value,
        selectedInspection: inspection,
        otherInspection: null,
        service: null,
      },
      () => {
        if (~value) {
          const { externalTaxAuthority, getExternalTaxAuthority } = this.props;

          if (!externalTaxAuthority.getIn(['data', value])) {
            getExternalTaxAuthority(value);
          }
        }
      },
    );
  };

  onSubmit = (event) => {
    event.preventDefault();
    const { makeAppointment } = this.props;
    const { service, timeSlot, selectedInspection, otherInspection, taxCode } = this.state;
    const inspection = ~taxCode && !otherInspection ? selectedInspection : otherInspection;
    const taxAuthority = Object.assign({}, inspection, {
      address: inspection.address || inspection.contacts,
    });

    const taxData = this.getCurrentInspectionData();
    const data = {
      fnsId: taxData.taxId,
      codeSoun: taxData.taxCode,
      serviceName: service.name,
      appointmentDateTime: moment.parseZone(timeSlot.visitTime).format('YYYY-MM-DD HH:mm:SS'),
      book: {
        fnsserviceID: timeSlot.fnsserviceID,
        visitTime: timeSlot.visitTime,
        faceID: service.faceID || defaultFaceId,
        lastName: '',
        firstName: '',
        middleName: '',
        mobilePhone: '',
        email: '',
        inn: '',
      },
    };
    makeAppointment({ data, taxAuthority });
  };

  getCurrentInspectionData = () => {
    const { selectedInspection, otherInspection, taxCode } = this.state;
    const otherInspectionId = otherInspection ? otherInspection.id : null;
    const inspectionId = ~taxCode && selectedInspection ? selectedInspection.id : null;
    const otherInspectionCode = otherInspection ? otherInspection.codeSOUN : null;
    const inspectionCode = ~taxCode && selectedInspection ? selectedInspection.codeSOUN : null;
    const isOtherInspection = !(~taxCode && !otherInspection);
    const visible = isOtherInspection
      ? get(otherInspection, 'visible')
      : get(selectedInspection, 'visible');
    return {
      taxId: isOtherInspection ? otherInspectionId : inspectionId,
      taxCode: isOtherInspection ? otherInspectionCode : inspectionCode,
      visible: visible !== false,
    };
  };

  hasServicesError = () => {
    const {
      externalTaxAuthority,
      managements,
      taxAuthorities,
      taxAuthorityAffiliates,
      services,
      slots,
    } = this.props;

    return (
      externalTaxAuthority.get('error') ||
      managements.get('error') ||
      taxAuthorities.get('error') ||
      taxAuthorityAffiliates.get('error') ||
      services.get('error') ||
      slots.get('error')
    );
  };

  getRegionError() {
    const { managements, externalTaxAuthority } = this.props;
    const { taxCode } = this.state;
    const taxAuthorityRegion = get(externalTaxAuthority.getIn(['data', taxCode]), 'parentID');
    const region = taxAuthorityRegion && managements.getIn(['data', taxAuthorityRegion.toString()]);

    return region && !region.visible;
  }

  isDisabledSubmitButton = () => {
    const { selectedInspection, otherInspection, service, timeSlot } = this.state;
    const hasInspection = selectedInspection || otherInspection;

    return !(hasInspection && service && timeSlot);
  };

  onSelectOtherInspection = (otherInspection) => {
    this.setState({
      otherInspection,
      service: null,
    });
  };
  renderInspections = () => {
    const { contacts } = this.props;
    const data = contacts.get('data');
    const inspections = data ? values(data.toJS()) : [];
    const items = this.getInspectionsItems(inspections);

    return (
      <RadioGroup
        items={items}
        selectedValue={this.state.taxCode}
        onChange={this.onSelectInspection}
      />
    );
  };

  renderLoadingButton = () => {
    return (
      <div
        className="button button__medium button__100 button__orange"
        style={{ position: 'relative' }}
      >
        <Loading isLight={true} />
      </div>
    );
  };

  renderSubmitButton = () => {
    return (
      <Button
        value="Записаться на прием"
        hasWrapper={false}
        color="orange"
        size="medium"
        isDisabled={this.isDisabledSubmitButton()}
        onClick={this.onSubmit}
        isFullWidth={true}
      />
    );
  };

  renderExternalTaxAuthorityLoading = () => {
    return (
      <div className="loading-container loading-container__big">
        <Loading />
      </div>
    );
  };

  renderExternalTaxAuthorityAffiliates = () => {
    const { externalTaxAuthority } = this.props;
    const { taxCode } = this.state;
    const loading = externalTaxAuthority.get('loading');
    const taxAuthority = externalTaxAuthority.getIn(['data', taxCode]);

    if (loading || !taxAuthority) {
      return this.renderExternalTaxAuthorityLoading();
    }
    return (
      <TaxAuthoritySelectContainer onSelect={this.onSelectOtherInspection} parent={taxAuthority} />
    );
  };

  renderLoading = () => {
    return (
      <div className="loading-container white-block white-block__pad40 contacts page__mobile">
        <Loading />
      </div>
    );
  };

  renderPage = () => {
    const { appointment } = this.props;
    const loading = appointment.get('loading');
    const data = appointment.get('data');
    const error = appointment.get('error');
    const { service, taxCode, selectedDate, timeSlot } = this.state;
    const taxData = this.getCurrentInspectionData();
    let errorMessage = error || null;
    const hasServicesError = this.hasServicesError();
    const regionError = this.getRegionError();

    if (!REACT_CONFIG.REACT_APP_HIDE_COVID_19) {
      return (
        <div className="white-block white-block__pad40 contacts page__mobile">
          <Warning
            message={
              <span className="justify">
                ФНС России во исполнение поручения заместителя Председателя Правительства Российской
                Федерации - Руководителя Аппарата Правительства Российской Федерации Д.Ю. Григоренко
                от 25.03.2020 №ДГ-П17-2301кв приостанавливает прием и обслуживание
                налогоплательщиков в налоговых инспекциях и их подразделениях с 30 марта по 15 мая
                2020 года.
              </span>
            }
          />
        </div>
      );
    }

    if (data && data.error) {
      errorMessage = data.error;
    }

    return (
      <div className="white-block white-block__pad40 contacts page__mobile">
        <form className="form">
          <div className="form_item form_item__part">
            <div className="form_label">Выберите налоговый орган*</div>
            {this.renderInspections()}
            {hasServicesError ? <Warning message={errorMessages.appointmentServiceError} /> : null}
          </div>
          {regionError && this.renderRegionError()}
          {!hasServicesError && !regionError ? (
            !~taxCode ? (
              <TaxAuthoritySelectContainer onSelect={this.onSelectOtherInspection} />
            ) : (
              this.renderExternalTaxAuthorityAffiliates()
            )
          ) : null}
          {taxData.taxId && taxData.visible && !hasServicesError && !regionError ? (
            <ServiceSelectContainer
              taxAuthorityId={taxData.taxId}
              onSelect={(value) =>
                this.setState({ service: value, timeSlot: null, selectedDate: null })
              }
            />
          ) : null}
          {service && taxData.taxId && taxData.visible && !hasServicesError && !regionError ? (
            <SlotSelectContainer
              taxAuthorityId={taxData.taxId}
              serviceId={service.id}
              selectedDate={selectedDate}
              selectedSlot={timeSlot}
              onSelectSlot={(value) => this.setState({ timeSlot: value })}
              onSelectDate={(value) => this.setState({ selectedDate: value, timeSlot: null })}
            />
          ) : null}
          <div className="cRow profile_buttons">
            <div className="cCol cCol__33">
              {loading ? this.renderLoadingButton() : this.renderSubmitButton()}
            </div>
          </div>
          {errorMessage ? (
            <div className={classnames('form_error', { red: errorMessage })}>
              {errorMessage || null}
            </div>
          ) : null}
        </form>
      </div>
    );
  };

  renderRegionError() {
    return (
      <InfoMessage type={'error'} className={styles.smMessage}>
        {defaultMessages.region}
      </InfoMessage>
    );
  }

  render() {
    const { contacts } = this.props;
    const loading = contacts.get('loading');

    return (
      <div className="page">
        <div className="page-title">
          <h1>Записаться на прием в налоговый орган</h1>
        </div>

        {loading ? this.renderLoading() : this.renderPage()}
      </div>
    );
  }
}
